import ExpirationColumn from './ExpirationColumn';
import type { ExpirationColumnProps } from './types';

export default ExpirationColumn;
export type { ExpirationColumnProps };
